import React, { PureComponent } from "react";
import {
  SortableContainer,
  SortableElement,
  SortableHandle
} from "react-sortable-hoc";
import { arrayMove } from "Utils";
import classnames from "classnames";

import styles from "./Settings.local.scss";
import Switch from "Common/Switch/Switch";
import _ from "i18n";
import Bloc from "../Bloc";
import Tooltip from "./Tooltip";

const widgets = [
  { key: "TALK_FLOAT", label: _("Talk Float") },
  { key: "WHERETOBILL", label: _("Where to Bill") },
  { key: "ARTICLE", label: _("Article editor") },
  { key: "TAMTAMIT", label: _("Tamtamit") },
  { key: "SENDING", label: _("Sending") }
];

const apps = [
  { key: "DASHBOARD", label: _("Dashboard") },
  { key: "POWERTEAM", label: _("PowerTeam") }
];

const DragHandle = SortableHandle(() => (
  <span className={styles.drag}>
    <span />
  </span>
));

const SortableItem = SortableElement(({ value, indexSetting }) => (
  <div className={styles.bloc}>
    <DragHandle />
    {<Bloc {...value} indexSetting={indexSetting} />}
  </div>
));

const SortableList = SortableContainer(({ items, indexSetting }) => {
  return (
    <div>
      {items.map((value, index) => {
        return (
          <SortableItem
            key={`item-${value.type}-${index}`}
            index={index}
            indexSetting={indexSetting}
            value={value}
          />
        );
      })}
    </div>
  );
});

export default class SettingsComponent extends PureComponent {
  constructor(props) {
    super(props);
    let config = [...this.props.config];
    this.state = {
      name:
        this.props.name !== "-"
          ? this.props.name
          : `Layout - ${this.props.indexSetting + 1}`,
      checkedItems: this.props.scope || [],
      selectedGroups: this.props.group || [],
      selectedWidgets: this.props.widgets || [],
      selectedApps: this.props.apps || [],
      items: config
        ? config.sort((a, b) => {
            return a.order - b.order;
          })
        : [],
      displayWidget: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      this.setState({
        name:
          this.props.name !== "-"
            ? this.props.name
            : `Layout - ${this.props.indexSetting + 1}`,
        checkedItems: this.props.scope || [],
        selectedGroups: this.props.group || [],
        selectedWidgets: this.props.widgets || [],
        selectedApps: this.props.apps || [],
        items:
          this.props.config.lentgth > 0
            ? this.props.config.sort((a, b) => {
                return a.order - b.order;
              })
            : this.props.config
      });
    }
  }

  disabledBtn = () => {
    const { checkedItems, selectedGroups } = this.state;
    return (
      !checkedItems.CLIENT &&
      !checkedItems.COLLABORATOR &&
      !checkedItems.MEMBER &&
      selectedGroups.length === 0
    );
  };

  setCheckedItems = (name, value) => {
    const { indexSetting, setScope, setWidgets } = this.props;
    if (name === "ALL") {
      this.setState(
        {
          checkedItems: value ? [name] : []
        },
        () => {
          setScope(this.state.checkedItems, indexSetting);
          if (!this.state.checkedItems.includes("CLIENT")) {
            this.setState(
              {
                selectedWidgets: this.state.selectedWidgets.filter(
                  item => item !== "WHERETOBILL"
                )
              },
              () => {
                setWidgets(this.state.selectedWidgets, indexSetting);
              }
            );
          }
        }
      );
    } else {
      this.setState(
        {
          checkedItems: value
            ? [...this.state.checkedItems.filter(item => item !== "ALL"), name]
            : this.state.checkedItems.filter(item => item !== name)
        },
        () => {
          setScope(this.state.checkedItems, indexSetting);
          if (!this.state.checkedItems.includes("CLIENT")) {
            this.setState(
              {
                selectedWidgets: this.state.selectedWidgets.filter(
                  item => item !== "WHERETOBILL"
                )
              },
              () => {
                setWidgets(this.state.selectedWidgets, indexSetting);
              }
            );
          }
        }
      );
    }
  };

  setSelectedGroups = groups => {
    const { setGroup, indexSetting } = this.props;
    this.setState(
      {
        selectedGroups: groups
      },
      () => {
        setGroup(this.state.selectedGroups, indexSetting);
      }
    );
  };

  renderTags = () => {
    const { checkedItems } = this.state;
    const trans = {
      ALL: _("all"),
      CLIENT: _("clients"),
      COLLABORATER: _("collaborators"),
      MEMBER: _("members"),
      GROUP: _("groups")
    };
    return (
      <ul>{checkedItems.map(name => <li key={name}>{trans[name]}</li>)}</ul>
    );
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    const { indexSetting } = this.props;
    this.props.setBlocsOrder(oldIndex, newIndex, indexSetting);
  };

  newDrawer = e => {
    const { addNewDrawer, indexSetting } = this.props;

    addNewDrawer(indexSetting);
  };

  onChangeName = e => {
    const { setLayoutName, indexSetting } = this.props;
    this.setState(
      {
        name: e.currentTarget.value
      },
      () => {
        setLayoutName(this.state.name, indexSetting);
      }
    );
  };

  handleDisplayWidgets = e => {
    const { displayWidget } = this.state;

    const body = $(e.target)
      .parent()
      .next("." + styles.widgetBody);

    if (displayWidget) {
      body.slideUp(500);
    } else {
      body.slideDown(500);
    }
    this.setState({ displayWidget: !displayWidget });
  };

  changeWidget = (widget, value) => {
    const { setWidgets, indexSetting } = this.props;
    const { selectedWidgets } = this.state;

    if (value) {
      this.setState({ selectedWidgets: [...selectedWidgets, widget] }, () => {
        setWidgets(this.state.selectedWidgets, indexSetting);
      });
    } else {
      this.setState(
        {
          selectedWidgets: selectedWidgets.filter(item => item !== widget)
        },
        () => {
          setWidgets(this.state.selectedWidgets, indexSetting);
        }
      );
    }
  };

  changeApp = (appKey, value) => {
    const { setApps, indexSetting } = this.props;
    const { selectedApps } = this.state;

    if (value) {
      this.setState({ selectedApps: [...selectedApps, appKey] }, () => {
        setApps(this.state.selectedApps, indexSetting);
      });
    } else {
      this.setState(
        {
          selectedApps: selectedApps.filter(item => item !== appKey)
        },
        () => {
          setApps(this.state.selectedApps, indexSetting);
        }
      );
    }
  };

  render() {
    const { auth, indexSetting, openModalDelete } = this.props;
    const { selectedWidgets, selectedApps, checkedItems } = this.state;

    return (
      <div className={styles.settings}>
        <input
          className={styles.name}
          type="text"
          value={this.state.name}
          onChange={e => this.onChangeName(e)}
        />

        <p>{_("Activate/deactivate or Change the order of blocs")}</p>
        <div
          className={classnames(styles.close, "close")}
          onClick={() => openModalDelete(indexSetting)}
        />
        <div className={styles.wrapTags}>
          <div className={styles.tags}>
            {_("configure_for")}
            {this.renderTags()}
          </div>
          <div className={styles.icon} onClick={this.toogleTooltip}>
            <img alt="settings" src="/img/icons/settings.svg" />

            <Tooltip
              checkedItems={this.state.checkedItems}
              setCheckedItems={this.setCheckedItems}
              setSelectedGroups={this.setSelectedGroups}
              selectedGroups={this.state.selectedGroups}
              auth={auth}
            />
          </div>
        </div>

        <SortableList
          items={this.state.items}
          onSortEnd={this.onSortEnd}
          indexSetting={this.props.indexSetting}
          useDragHandle
        />

        <div className={styles.actionsContainer}>
          <div className={styles.addDrawer} onClick={this.newDrawer.bind(this)}>
            <button className={styles.plus} />
            <span>{_("Add new drawer")}</span>
          </div>

          <div
            className={styles.addWidget}
            onClick={this.handleDisplayWidgets.bind(this)}
          >
            {_("Activate Widgets / Apps")} ({selectedWidgets.length +
              selectedApps.length})
          </div>
        </div>

        <div className={styles.widgetBody}>
          <h3>Widgets</h3>
          <div className={styles.widgetContainer}>
            {widgets.map(widget => {
              if (
                widget.key === "WHERETOBILL" &&
                !checkedItems.includes("CLIENT")
              ) {
                return null;
              }
              return (
                <div key={`widget${widget.key}`} className={styles.widgetBloc}>
                  <span>{widget.label}</span>
                  <Switch
                    checked={selectedWidgets.includes(widget.key)}
                    onChange={this.changeWidget.bind(this, widget.key)}
                  />
                </div>
              );
            })}
          </div>
          <h3 className={styles.apps}>Apps</h3>
          <div className={styles.widgetContainer}>
            {apps.map(app => {
              return (
                <div key={`app${app.key}`} className={styles.widgetBloc}>
                  <span>{app.label}</span>
                  <Switch
                    checked={selectedApps.includes(app.key)}
                    onChange={this.changeApp.bind(this, app.key)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Settings/SettingsComponent.js